import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';

Alpine.plugin(intersect);

/**
 * Setting up a store for modals.
 */
document.addEventListener('alpine:init', () => {
	Alpine.data('popupLogic', (daysToRepeat) => ({
		show: false,
		daysToRepeat: parseInt(daysToRepeat) || 30,

		checkPopup() {
			// Check cookie
			if (document.cookie.includes('dyanne_platform_popup_closed=true')) return;

			const currentPage = window.location.pathname;
			const visited = JSON.parse(sessionStorage.getItem('visited_pages') || '[]');


			 // Alleen toevoegen als nog niet bezocht
			if (!visited.includes(currentPage)) {
				visited.push(currentPage);
				sessionStorage.setItem('visited_pages', JSON.stringify(visited));
			}

			if (visited.length >= 3) {
				setTimeout(() => {
					this.show = true;
				},
				3000);
			}
		},

		closePopup() {
			this.show = false;

			const expiryDate = new Date();
			expiryDate.setDate(expiryDate.getDate() + this.daysToRepeat);

			document.cookie = `dyanne_platform_popup_closed=true; expires=${expiryDate.toUTCString()}; path=/`;
		}
	}));
});

jQuery(document).on('gform_confirmation_loaded', function (form, formId) {
	const popupForm = document.getElementById('gf_' + formId);

	if(!popupForm){
		return;
	}

	if (!popupForm.nextSibling.classList.contains('gform_pop-up')) {
		return;
	}

	const popupEl = popupForm.closest('[x-data]');
	const popup = popupEl ? Alpine.$data(popupEl) : null;

	const countdownEl = document.querySelector('.countdown');
	let seconds = 5;

	if (countdownEl) {
		countdownEl.textContent = seconds;

		const interval = setInterval(() => {
			seconds--;
			countdownEl.textContent = seconds;

			if (seconds <= 0) {
				clearInterval(interval)
			};
		}, 1000);
	}

	setTimeout(() => {
		if (popup && typeof popup.closePopup === 'function') {
			popup.closePopup();
		}
	},
	5000);
});

/**
 * The window.Alpine = Alpine bit is optional, but is nice to have for freedom and flexibility.
 * Like when tinkering with Alpine from the devtools for example.
 */
window.Alpine = Alpine;

/**
 * Ensure that Alpine.start() is only called once per page.
 * Calling it more than once will result in multiple "instances" of Alpine running at the same time.
 */
Alpine.start();
